import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, tap } from 'rxjs';

import { Module } from '../référentiel-métier-parcours/models/module.model';
import { EtapeStore } from '../référentiel-métier-parcours/parcours-etape/store/etape.store';
import { ModuleService } from '../référentiel-métier-parcours/parcours-module/parcours-module.service';
import { ModuleStore } from '../référentiel-métier-parcours/parcours-module/store/module.store';
import { SequenceStore } from '../scénarisation/store/sequence.store';

export const scenarisationResolver: ResolveFn<Observable<Module> | undefined> = (route) => {
  const sequenceStore = inject(SequenceStore);

  const moduleStore = inject(ModuleStore);
  const moduleService = inject(ModuleService);

  const etapeStore = inject(EtapeStore);
  const idModule = route.paramMap.get('idModule');
  const idSéquence = route.queryParamMap.get('idSequence');

  if (!idModule) return undefined;

  return moduleService.trouveParId(idModule).pipe(
    tap((module) => {
      moduleStore.ajouterModule(module);
      moduleStore.selectionnerModule(module);
      etapeStore.selection(module.idEtape);
      sequenceStore.chargerSequences({ sequences: module.sequences });
    }),
    tap(() => {
      if (idSéquence) sequenceStore.selection(idSéquence);
    }),
  );
};
